<template>
  <el-dialog
    :model-value="props.visible"
    title="名单待跟进通知"
    width="600"
    top="20vh"
    destroy-on-close
    :close-on-click-modal="false"
    @open="onOpen"
    @closed="closedModal"
  >
    <div class="notice-content">
      <p class="notice-item">
        因意向学员10天未填写跟进记录或30天未成交，需将现有{{ props.showDataInfo.count }}个客户名单做跟进处理。</p>
      <p class="notice-desc">为确保客户服务平稳过渡，防止潜在流失，</p>
      <p class="notice-desc">请您尽快登录CRM系统，完成名单认领及分配工作。</p>
      <p class="notice-time">通知时间:{{ props.showDataInfo.time }}</p>
    </div>

    <div class="my-footer">
      <el-button type="primary" @click="handleGoToOperation">前往操作</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import {useRouter} from "vue-router";
import useUserStore from "@/store/modules/user.js";

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  showDataInfo: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:visible',])

function onOpen() {
}

const router = useRouter()
const userStore = useUserStore();

function handleGoToOperation() {
  let query = {
    key: "listStatistics",
    ownerid: userStore.userInfo.userId,
  };
  router.push({
    name: "Intention",
    query,
  });
  emit('update:visible', false)
}

function closedModal() {
  emit('update:visible', false)
}
</script>

<style scoped lang="scss">
.notice-content {
  padding: 20px 0;
  line-height: 1.8;

  .notice-item {
    font-size: 14px;
    color: #333;
    margin-bottom: 16px;
  }

  .notice-desc {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
    padding-left: 0;
  }

  .notice-time {
    font-size: 14px;
    color: #333;
    margin-top: 24px;
  }
}

.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
